import React from 'react';
import styled from 'styled-components';
import { SelectTerms } from '../shared';
import { useTranslation } from 'react-i18next';
import { SlideSection, SliderContainer, TermExplanation, TermLabel, SectionHeader } from '../styles';
import { useSlideData } from '@context/slide-data';
import { SectionLabel } from '../shared';
import { TermOptionsTable } from '../shared/TermOptionsTable';
import { QUERY_KEYS, SHARED_STYLES } from '@constants';
import { useQueryClient } from 'react-query';

const TermOptionsStyle = styled.div`
    width: 100%;
    height: 100%;
`;

export const TermOptions = () => {
    const queryClient = useQueryClient();
    const { primaryLightBlue, secondaryLightBlue } = SHARED_STYLES;
    const { t } = useTranslation();
    const { currentSlideQuery } = QUERY_KEYS;
    const { data, slideState, sectionsVisible, desktop } = useSlideData();
    const { id, details: termOptions } = data;
    const { currentMonthlyPayment } = termOptions;
    const { availableTerms } = slideState;

    const selectedTerm = slideState.selectedTerm[id];
    const selectedScriptSection = slideState.selectedSection?.[id];

    // To-do: reload automatically after a timeout
    if (availableTerms.length && !availableTerms.includes(selectedTerm)) {
        queryClient.invalidateQueries([currentSlideQuery, id], {
            refetchInactive: true
        });
    
        return <div>Reloading term options...please refresh if terms don&apos;t reload within a few seconds.</div>
    }

    const { 
        termDescription,
        monthlySavings, 
        annualSavings, 
        totalSavings,  
        newMonthlyPayment 
    } = termOptions[selectedTerm];

    const tableOneData = [
        {
            label: t('term_options.term_label'),
            value:  `${termDescription} ${t('global.months')}`
        },
        {
            label: t('term_options.current_payment'),
            value: currentMonthlyPayment
        }
    ];

    const tableTwoData = [
        {
            label: t('term_options.savings.monthly'),
            value:  monthlySavings
        },
        {
            label: t('term_options.savings.annual'),
            value: annualSavings
        },
        {
            label: t('term_options.savings.total'),
            value: totalSavings
        }
    ];

    return (
        <TermOptionsStyle>
            <SlideSection
                selected={selectedScriptSection === 1}
                visible={sectionsVisible}>
                    <SectionLabel section={1} />
                    <SectionHeader>{t('term_options.terms_header')}</SectionHeader>
                    <TermOptionsTable data={tableOneData} cellColor={secondaryLightBlue} />
                    <label htmlFor='slider'>
                        <SectionHeader>{t('term_options.slider_title')}</SectionHeader>
                    </label>
                    <SliderContainer desktop={desktop}>
                        <SelectTerms
                            value={selectedTerm}
                            options={termOptions}/>
                        <TermExplanation desktop={desktop}>
                            <TermLabel htmlFor='new-payment'>
                                {t('term_options.new_payment')}
                            </TermLabel>
                            <h2 id='new-payment'>{newMonthlyPayment}</h2>
                        </TermExplanation>
                    </SliderContainer>
            </SlideSection>
            <SlideSection
                selected={selectedScriptSection === 2}
                visible={sectionsVisible}>
                    <SectionLabel section={2} />
                    <SectionHeader>{t('global.savings')}</SectionHeader>
                    <TermOptionsTable cellColor={primaryLightBlue} data={tableTwoData}/>
            </SlideSection>
        </TermOptionsStyle>
    );
};

export default TermOptions;
